import React, { useEffect, useState, useRef, useContext } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { toRelativeUrl } from '@okta/okta-auth-js';
import { Outlet, useNavigate } from 'react-router-dom';
import Loader from '../commons/Loader';
import Api from '../Api';
import { globalContext } from "../store";
import { checkAuthErr, checkUnauthorized } from '../commons/commonFunctions';

export interface UserRoles {
  name: string;
  addedTs: string;
  lastUpdatedTs: string;
}

export interface IMeData {
  id: string;
  addedTs: string;
  lastUpdatedTs: string;
  firstName: string;
  lastName: string;
  userName: string;
  roles: UserRoles[];
  //privacyPolicies: IPrivacyPolicy[];
  //applications: IMeApplications;
  clientId?: string;
}

const fetchData = async (subDomain: any, oktaAuth: any, authState: any, apiCalled: any, setToggle: any, dispatch: any, navigate: any) => {
  if ((authState === undefined || !authState || !authState.isAuthenticated) && ((!sessionStorage.getItem('loginToken')) || JSON.parse(
    sessionStorage.getItem("loginToken") ?? "false"
  ) === null)) {
    const originalUri = toRelativeUrl(window.location.href, window.location.origin);
/**
 * RequiredAuth.tsx
 *
 * This file provides a React route guard component for authentication and client context setup.
 * It uses Okta for authentication and fetches client data based on the current domain.
 * If the user is not authenticated, it redirects to Okta login. If authenticated, it fetches client info and sets it in global state.
 * The component renders a Loader while authentication and client data are being resolved, and renders child routes (Outlet) once ready.
 *
 * Key responsibilities:
 * - Enforce authentication using Okta
 * - Fetch client data by domain and store in global context
 * - Handle redirects and error states
 * - Provide type definitions for user and client data
 */
    oktaAuth.setOriginalUri(originalUri);
    oktaAuth.signInWithRedirect();
    return <Loader />
  }
  sessionStorage.setItem('loginToken', JSON.stringify(authState));
  if (authState !== null) {
    apiCalled.current = true;
    Api.getClientByDomain(subDomain)
      .then((res: any) => {
        if (res?.success) {
          if (res?.response?.data?.data?.[0]) {
            dispatch({
              type: "SET_CLIENT_DATA",
              payload: res?.response?.data?.data?.[0],
            });
            sessionStorage.setItem('clientId', JSON.stringify(res?.response?.data?.data[0]?.id));
          } else {
            navigate('/error')
          }
        }
        setToggle(true);
        checkUnauthorized(res, dispatch)
      }).catch((err: any) => {
        console.log(err);
        checkAuthErr(err, dispatch)
      });
  }
};

export const RequiredAuth = () => {
  const { dispatch } = useContext(globalContext);

  const navigate = useNavigate();
  const { oktaAuth, authState } = useOktaAuth();
  const [toggle, setToggle] = useState<boolean>(false)
  const apiCalled = useRef(false);
  const subDomain = window.location.host === 'localhost:3000' ? 'leahtestingonly.test-leaders.heidrickassessment.com' : window.location.host;
//https://leahtestingonly.test-leaders.heidrickassessment.com
  useEffect(() => {
    if (apiCalled.current) return;
    fetchData(subDomain, oktaAuth, authState, apiCalled, setToggle, dispatch, navigate);
  }, [authState]);

  return toggle ? <Outlet /> : <Loader />;
};
